import { AudioBackgroundSettings } from '@/types/audio';
import { StoreApi } from 'zustand';
import { StudioVideo } from './studioVideoStore';
import { CompletedStandaloneMediaAsset } from '@/types/media';

export type GeneratedBackgroundMusicClip = CompletedStandaloneMediaAsset;

export type AudioBackground = {
  audioBackground?: AudioBackgroundSettings;
};

export type AudioBackgroundSliceState = {
  audioBackgroundEnabed: boolean;
  audioBackground?: AudioBackgroundSettings;
  parentAudioBackground?: AudioBackgroundSettings;
  generatedBackgroundMusicClips: GeneratedBackgroundMusicClip[];
};

export type AudioBackgroundSliceActions = {
  toggleAudioBackground: (audioBackgroundEnabed: boolean) => void;
  setAudioBackground: (audioBackground?: AudioBackgroundSettings) => void;
  setGeneratedBackgroundMusicClips: (generatedBackgroundMusicClips: GeneratedBackgroundMusicClip[]) => void;
  addGeneratedBackgroundMusicClips: (generatedBackgroundMusicClips: GeneratedBackgroundMusicClip[]) => void;
};

type AudioBackgroundSlice = AudioBackgroundSliceState & AudioBackgroundSliceActions;

export const initAudioBackgroundSliceState = (studioVideo?: StudioVideo): AudioBackgroundSliceState =>
  studioVideo
    ? {
        audioBackgroundEnabed: !!studioVideo.audioBackground,
        audioBackground: studioVideo.audioBackground?.autogenerated === false ? studioVideo.audioBackground : undefined,
        parentAudioBackground: studioVideo.audioBackground,
        generatedBackgroundMusicClips: [],
      }
    : {
        audioBackgroundEnabed: true,
        audioBackground: undefined,
        parentAudioBackground: undefined,
        generatedBackgroundMusicClips: [],
      };

export const createAudioBackgroundSliceActions = (
  set: StoreApi<AudioBackgroundSlice>['setState']
): AudioBackgroundSliceActions => ({
  toggleAudioBackground: (audioBackgroundEnabed: boolean) => set({ audioBackgroundEnabed }),

  setAudioBackground: (audioBackground?: AudioBackgroundSettings) => set({ audioBackground }),

  setGeneratedBackgroundMusicClips: (generatedBackgroundMusicClips: GeneratedBackgroundMusicClip[]) =>
    set({ generatedBackgroundMusicClips }),

  addGeneratedBackgroundMusicClips: (generatedBackgroundMusicClips: GeneratedBackgroundMusicClip[]) =>
    set((state) => ({
      generatedBackgroundMusicClips: [...state.generatedBackgroundMusicClips, ...generatedBackgroundMusicClips],
    })),
});
